import { useEffect } from 'react'
import NavTop from '../components/common/NavTop'
import HomeNav from '../components/home/HomeNav'
import AboutCompany from '../components/common/AboutCompany'
import OurPrice from '../components/common/OurPrice'
import TestimonialComponent from '../components/common/TestimonialComponent'
import WhyUs from '../components/common/WhyUs'
import Faqs from '../components/common/Faqs'
import SmallNavbar from '../components/common/SmallNavbar'
import CoverageDetails from '../components/common/CoverageDetails'
import Footer from '../components/common/Footer'
import NumbersIncrement from '../components/common/NumbersIncrement'
import BrandSlider from '../components/common/BrandSlider'
import ContactButtons from '../components/common/ContactButtons'
import LandingHeader from '../components/home/LandingHeader'
import CustomerFeedback from "../components/common/CustomerFeedback"

const HomePage = () => {


  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);
  
  
  return (
    <div>

<div className="home-page">
  

      {/* <FixButtonWa/>
      <FixButtonCall/> */}
      
      <ContactButtons/>

      
      <div className="small-nav-fixed">
      <SmallNavbar/>
        </div>
      

      <NavTop/>
      <div className="web-nav-fixed"><HomeNav/></div>
      
      <LandingHeader/>
      {/* <HomeHeader/> */}

      <NumbersIncrement/>
      <OurPrice/>

      <AboutCompany/>
      {/* <ServiceBrand /> */}
      {/* <BrandSlider /> */}
      <WhyUs/>
      {/* <TestimonialComponent/> */}
      <CustomerFeedback/>

      <Faqs/>
      <CoverageDetails/>

      <Footer/>


      
    </div>
    </div>
  )
}

export default HomePage